import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

type Question = {
  id: number;
  title: string;
  description: string;
}

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})
export class FaqsComponent implements OnInit {
  faqSelected = undefined;
  faqs: Question[] = [];

  constructor(private translocoService: TranslocoService) { }

  ngOnInit(): void {
    this.translocoService.selectTranslate('faq.questions').subscribe((questions: Question[]) => {
      this.faqs = questions.map((q, index) => ({
        ...q,
        id: index
      }));
    });
  }

  openFaq(value: any) {
    this.faqSelected = this.faqSelected === value ? undefined : value;
  }
}
